var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ErrorRow',{attrs:{"error":_vm.error}}),_vm._l((_vm.comments),function(comment){return _c('div',{key:comment.id()},[_c('CommentLayout',{attrs:{"commentData":comment.data}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }